import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const Home = lazy(() => import('Containers/Home/Home'));

const routes = [
  {
    path: '/home',
    exact: true,
    ContentComponent: Home,
    Layout: MainLayout,
  },
];

export default routes;
